<div class="modal-body">
    <iframe [src]="safeUrl" style="height: 25rem;width: -webkit-fill-available;" *ngIf="showIfream"></iframe>

    <div *ngIf="!showIfream">
        <form class="g-3" name="EsignDetailForm" (ngSubmit)="Validate(EsignDetailForm,'EsignDetailForm')"
            #EsignDetailForm="ngForm" novalidate>
            <div class="row py-2">
                <div class="col"></div>
                <div class="col-md-4">
                    <label for="email" class="text-label-dark">EmailID <span class="mandatory-field">*</span></label>
                    <input type="email" class="form-control" placeholder="Ex. xyz@domain.com" id="email" name="email"
                        [(ngModel)]="email" pattern="[A-Za-z0-9._+\-']+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$" required>
                    <div class="invalid-feedback">
                        Please enter a valid email id! eg. 'example&#64;abc.com'
                    </div>
                </div>
                <div class="col"></div>
            </div>
            <div class="row py-2">
                <div class="col"></div>
                <div class="col-md-4">
                    <label for="city" class="text-label-dark">City <span class="mandatory-field">*</span></label>
                    <input type="text" class="form-control" placeholder="Ex. Mumbai" id="city" name="city"
                        [(ngModel)]="city" maxlength="100">
                    <div class="invalid-feedback">
                        Please enter city!
                    </div>
                </div>
                <div class="col"></div>
            </div>
            <div class="row py-2">
                <div class="col"></div>
                <div class="col-md-4">
                    <button type="submit" class="btn btn-primary" style="width: -webkit-fill-available;"><i
                            class="bi bi-check"></i>
                        Submit</button>
                </div>
                <div class="col"></div>
            </div>
        </form>
    </div>
</div>
<div class="modal-footer">
    <!-- <button type="button" class="btn btn-primary" (click)="close(true)" *ngIf="showIfream"><i class="bi bi-check"></i>
        OK</button> -->
    <button type="button" class="btn btn-outline-primary" (click)="close(showIfream)" ><i class="bi bi-x"></i>
        Close</button>
</div>